var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRoundVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5953_16341)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4163 7L11.993 5.3725L12.1913 3.22L10.0855 2.74167L8.98301 0.875L6.99967 1.72667L5.01634 0.875L3.91384 2.73583L1.80801 3.20833L2.00634 5.36667L0.583008 7L2.00634 8.6275L1.80801 10.7858L3.91384 11.2642L5.01634 13.125L6.99967 12.2675L8.98301 13.1192L10.0855 11.2583L12.1913 10.78L11.993 8.6275L13.4163 7ZM5.47134 9.33917L4.08301 7.93917C4.02893 7.8852 3.98603 7.8211 3.95675 7.75053C3.92748 7.67996 3.91241 7.60431 3.91241 7.52792C3.91241 7.45152 3.92748 7.37587 3.95675 7.3053C3.98603 7.23473 4.02893 7.17063 4.08301 7.11667L4.12384 7.07583C4.35134 6.84833 4.72467 6.84833 4.95217 7.07583L5.89134 8.02083L8.89551 5.01083C9.12301 4.78333 9.49634 4.78333 9.72384 5.01083L9.76467 5.05167C9.99217 5.27917 9.99217 5.64667 9.76467 5.87417L6.31134 9.33917C6.07217 9.56667 5.70467 9.56667 5.47134 9.33917Z",
    fill: "#147BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5953_16341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundVerified);
export default __webpack_public_path__ + "static/media/ic_round-verified.d4ef68c5387a166e1b316b4159a842fd.svg";
export { ForwardRef as ReactComponent };